import "./src/styles/variables.css";
import "./src/styles/global.css";

// Smooth scroll polyfill for older browsers
if (typeof window !== "undefined") {
    import("smoothscroll-polyfill").then((smoothscroll) => {
        smoothscroll.polyfill();
    }).catch(() => {
        // Polyfill not critical, ignore if not available
    });
}
